import React from 'react'
import { FaExchangeAlt } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'

type DirectionalityControlProps = {
  toggleDirectionalityActive: () => void
  isCreating: boolean
  isEditing: boolean
  disabled: boolean
  control: string
}

const DirectionalityControl = ({ toggleDirectionalityActive, isCreating, isEditing, disabled, control }: DirectionalityControlProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    if (isCreating || isEditing || disabled) {
      return
    }
    toggleDirectionalityActive()
  }

  return (
    <div className={cn('control', 'directionality')} data-graph-type="control" title={`Toggle Direction ${control}`}>
      <a className={cn('icon', { disabled: isCreating || isEditing || disabled })} onClick={handleClick}>
        <FaExchangeAlt aria-hidden />
        <span className="sr-only">Toggle Directionality</span>
      </a>
    </div>
  )
}

export default DirectionalityControl
